const zh = {
  "test": "这是一个测试！",
  "start": "开始",
  "about_us": "关于我们？",
  "cert_services": "认证服务",
  "general_info": "一般信息",
  "news": "消息",
  "contact": "联系我们",
  "login": "登录",
  "about-us2": "关于我们",
  "accreditation": "认证",
  "electronics": "电气电子",
  "telecommunications": "电信",
  "energy-efficiency": "能源效率",
  "proc-cert": "认证流程",
  "public-info": "公共信息",
  "faq": "常见问题解答",
  "webinars": "网络研讨会",
  "complaints-appeals": "投诉和上诉",
  "meet-us": "来见我们",
  "cert-needs": "用信心和安全解决您的<em>认证需求</em>",
  "facilitating-compliance": "促进遵守<em>墨西哥官方标准</em>",
  "tech-sectors": "针对我们能够覆盖的<em>技术领域</em>",
  "welcome-to": "欢迎来到墨西哥认证机构 S.C.",
  "comp-desc": "一个致力于证明其产品符合墨西哥官方标准的产品认证机构",
  "cert-scope": "我们的认证范围",
  "elec-eng": "电气工程",
  "telecoms": "电信",
  "energy-eff": "能效",
  "professional-commit": "专业承诺",
  "more-than-years": "超过30年",
  "portal": "门户",
  "laws": "法律",
  "expert-staff": "拥有超过30年经验的高级评估人员，在安全、电信和能效方面的合规性评估方面经验丰富。",
  "prac-proc": "我们流程的实用性结合技术的使用，使我们能够在始终保持我们区别于他人的质量的同时，减少响应时间。",
  "const-training": "我们不断参与和培训标准化领域，为您提供最新信息和可靠的认证服务。",
  "new-regs": "新规定",
  "lorem": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  "read-more": "阅读更多",
  "quick-links": "快速链接",
  "contact_info": "联系信息",
  "privacy": "隐私",
  "user-agreement": "用户协议",
  "transparency": "透明度",
  "cookies-policy": "Cookie 政策",
  "about_us_intro_1": "墨西哥认证机构在墨西哥城成立，旨在支持和服务电子、电信和信息技术产业，以促进墨西哥的技术增长；确保遵守墨西哥官方标准（NOM）和其他现行法规，以保护消费者、环境，并确保公共电信网络的适当使用。",
  "about_us_intro_2": "我们拥有国内外覆盖，我们的非营利运营与私人资本整合，我们的收入来自我们提供的认证服务。",
  "effectiveness": "效果",
  "vangaurd": "先锋",
  "mission": "使命",
  "vision": "愿景",
  "mission_stmt": "代表墨西哥人民在产品认证方面的最高质量，遵循法规和立法过程。为评估的产品提供安全和信任，从而促进贸易和国家的增长",
  "vision_stmt": "成为具有国内外影响力的产品认证机构。在符合性评估的创新和卓越方面成为领导者，消除官僚障碍并简化规范流程，造福整个行业。",
  "values": "价值观",
  "impartiality": "公正性",
  "integrity": "正直",
  "trust": "信任",
  "excellence": "卓越",
  "efficiency": "效率",
  "responsibility": "责任",
  "collaboration": "合作",
  "gratitude": "感激",
  "impartiality_sub": "对内部流程的完全中立",
  "integrity_sub": "在所有情况下始终做正确的事",
  "trust_sub": "每天赢得我们用户的忠诚",
  "excellence_sub": "承诺拥有最合格的人员",
  "efficiency_sub": "致力于不断创新和持续改进结果",
  "responsibility_sub": "正式承担我们的义务",
  "collaboration_sub": "以共同的目标增加内外部结果",
  "gratitude_sub": "每天感谢有机会成为行业的一部分并在他人生活中做出差异",
  "accred-intro": "墨西哥认证机构S.C.是一个由墨西哥认证实体（ema）认证的产品认证机构，正在等待标准总局（DGN）和国家能源高效利用委员会（conuee）的批准，并获得电信监管委员会（CRT）的授权，根据我们的标准范围。",
  "accred-intro-2": "此外，我们拥有高素质的人员，并在符合性评估方面有丰富的经验；这使我们能够为用户提供安全、创新和经过验证的质量。",
  "accred-office": "EMA 认证文件",
  "nom001scfi2018_1": "电子设备-安全要求和测试方法",
  "nom001scfi2018_2": "使用公共电力能源供电的电子设备及其配件，供电电压为单相至277 V交流60 Hz和/或三相至480 V交流线间60 Hz；以及使用电池、蓄电池、自发电和其他能源源，如电池、电池、蓄电池、自发电和替代能源供电至500 V直流。",
  "nom001scfi2018_3": "使用公共电网电力和其他能源源（如电池、电池或蓄电池）供电的新电子设备/系统、二线产品、停产产品、重建产品、翻新产品、二手或旧产品。",
  "nom001scfi2018_4": "外部电源，与本官方墨西哥标准中包含的电子设备一起使用，或适用于NOM-019-SCFI-1998的应用领域，两种情况都用于直流电源至250 V和交流电源至480 V 60 Hz。",
  "mcb_scope": "墨西哥认证机构具有以下范围：",
  "av_equip": "音视频设备",
  "amuse_machines": "娱乐机器",
  "eups": "不间断电源系统",
  "eps": "外部电源",
  "elec_toys": "电子玩具",
  "misc_prods": "杂项或多样产品",
  "office_elec": "用于办公室的电子设备，由不同的电能源供电 安全要求和测试方法。",
  "nom016scfi1993_1": "涵盖用于办公室和学校的电子和机电设备，用于完成这些场所特定的各种工作。设定安全要求以及必须遵守的测试方法。",
  "nom016scfi1993_2": "此类设备包括电子打字机、复印机和/或文档复制机、电子计算器、电子黑板、传真设备和其他办公室和学校使用的设备。",
  "security_of_equip": "数据处理设备安全。",
  "security_spec": "电气电子产品。安全规范。",
  "security_spec_detail": "本标准适用于由公用电网或其他能源（如原电池、蓄电池、蓄能装置及自发电）供电的电气产品，这些产品使用交流电和/或直流电，且额定电压最高可达 1000 V 交流（AC）或 1500 V 直流（DC）。",
  "scopes_mcb_nmx": "墨西哥认证机构的认证范围如下：",
  "est_sec_reqs": "设定所有在墨西哥合众国领土上销售的数据处理设备外围设备或相关设备必须遵守的安全要求。被识别为数据处理机器的电子机器，如：",
  "sec_reqs_list_1": "便携式（笔记本电脑，手提电脑，掌上电脑）",
  "sec_reqs_list_2": "微型计算机",
  "sec_reqs_list_3": "个人系统，个人计算机",
  "sec_reqs_list_4": "个人使用计算机",
  "sec_reqs_list_5": "网络终端（Pc-net）",
  "sec_reqs_list_6": "服务器或等同物",
  "est_sec_reqs_2": "适用于单处理器并使用BUS-AT（ISA）或EISA或MCA或NUBUS或BIOS或PCI或PCMI或PMCIA技术的设备。以及与这些相关的外围设备，如打印机、图表绘制器、外部硬盘驱动器、外部磁带驱动器、数位板、图像数字化设备、光学阅读器、显示器和终端。",
  "est_sec_reqs_3": "用于数据处理设备和外围设备之间的电子通信的设备，局域网（LAN）等，如集线器、协议转换器或路由器等，专为处理单一技术设计，其数据总线不超过100 MBs，且不是模块化类型或没有编程能力。",
  "term_equipment": "通过有线接入连接或互联至公共电信网络的终端设备",
  "scope": "适用范围：",
  "products_terminal_equip": "这项墨西哥官方标准涉及的产品是所有通过有线接入连接或互联到公共电信网络的终端设备。",
  "products_terminal_example": "符合NOM要求的设备示例：",
  "products_telephones": "有线和无线电话，具有电话线路输出的交换机。",
  "network_interface": "公共网络数字接口（2 048 KBIT/S 和 34 368 KBIT/S数字接口）",
  "radio_interface_equipment": "这项墨西哥官方标准涉及的产品是所有具有公共电信网络数字接口的无线电通信设备（2 048 kbit/s 和 34 368 kbit/s数字接口）。",
  "equip_e1_e3": "具有数字接口E1和E3的设备",
  "radio_products": "产品。使用扩频技术的无线电通信系统和跳频及数字调制的无线电通信设备，操作频段为902 MHz-928 MHz、2400 MHz-2483.5 MHz 和 5725 MHz-5850 MHz—规格和测试方法。",
  "spread_spectrum_products": "这项墨西哥官方标准涉及的产品是所有使用扩频技术的无线电通信设备。",
  "wireless_devices": "配备ZigBee、WIFI、Bluetooth等技术的设备和设备。",
  "mobile_devices": "可使用无线电频谱或连接到电信网络的移动终端设备的规格。第1部分。设备制造身份代码（IMEI）和调频（FM）广播接收功能。",
  "mobile_devices_covered": "这项墨西哥官方标准涉及的产品是所有可能使用无线电频谱或连接到电信网络的移动终端设备。",
  "mobile_devices_covered_2": "在墨西哥国内使用国际漫游的移动终端设备除外。",
  "imei_devices": "任何可在网络上操作的设备都有一个IMEI代码",
  "imei_devices_2": "手机、平板电脑、路由器或具有蜂窝网络访问的调制解调器",
  "tech_spec_mobile_term": "可使用无线电频谱或连接到电信网络的移动终端设备的技术规格。第2部分。在700 MHz、800 MHz、850 MHz、1900 MHz、1700 MHz/2100 MHz和/或2500 MHz频段操作的移动终端设备。",
  "tech_spec_mobile_term_2": "这项墨西哥官方标准涉及的产品是所有可能在700 MHz、800 MHz、850 MHz、1900 MHz、1700 MHz/2100 MHz和/或2500 MHz频率带上使用无线电频谱或连接到电信网络的移动终端设备。预计在操作时不会对其他授权操作设备或墨西哥联邦电信研究所授权的电信网络和服务造成有害干扰。前述情况不影响遵守其他适用的法律和行政规定。",
  "tech_spec_cell": "可使用无线电频谱或连接到电信网络的移动终端设备的技术规格。第3部分。蜂窝广播服务用于风险或紧急情况通知。",
  "cell_scope_1": "这项技术规定适用于所有可能使用无线电频谱或连接到电信网络的移动终端设备（手机和/或智能手机），用于接收和处理通过蜂窝广播服务发出的风险或紧急情况警报消息。",
  "cell_scope_2": "在墨西哥国内使用国际漫游的移动终端设备以及配备SIM卡或eSIM卡并兼容蜂窝广播服务的智能手表（smartwatches）除外。这些智能手表可以接收和处理某种形式的警报消息，并且由于其技术特性，显示这些警报消息的视觉效果、听觉信号和振动节奏可能与手机和/或智能手机接收和处理的不同，其操作不受限制。",
  "cell_scope_3": "手机或智能手机",
  "non_ionizing_emissions": "为电信产品、设备、装置或器材设定无电离辐射电磁辐射最大限值的技术规格。比吸收率（SAR）。",
  "non_ionizing_emissions_2": "任何具有射频发射器或收发器、使用无线电频谱或连接到电信网络的产品、设备、装置或器材，其使用频率范围为30 MHz至6 GHz，并用于：",
  "non_ionizing_emissions_3": "a) 在300 MHz至6 GHz频率范围内，特别是靠近耳朵的头部附近，和/或",
  "non_ionizing_emissions_4": "b) 在人体30 MHz至6 GHz频率范围内小于或等于200 mm的距离",
  "energy_eff_power_supply_1": "外部电源的能效。限制、测试方法、标记和标签。",
  "energy_eff_power_supply_2": "设定测试方法和标记外部电源（FAE）的最小信息规格，这些电源旨在将交流（c.a.）线路电压转换为单一固定的直流（c.c.）输出电压级，此外：",
  "energy_eff_power_supply_3": "操作中的最低能效值。",
  "energy_eff_power_supply_4": "空载或空闲模式的最大电力限制。",
  "energy_eff_power_supply_5": "最大输出功率小于或等于250瓦。",
  "energy_eff_power_supply_6": "适用于所有进口、制造、市场化以及以促销目的分发或供应的FAE；无论是单独还是作为最终产品的一部分，在墨西哥合众国领土内。以及那些设有开关，允许用户手动选择不同输出电压级别的；在设计上物理确定并独立于产品的。",
  "can_certs": "已取消的证书",
  "office_appl_1": "设备和需要待机能量的设备的最大电力限制。测试方法和标签。",
  "office_appl_2": "这项墨西哥官方标准适用于以下电子设备和设备，这些设备使用100 V至277 V c.a.的单相供电电压和50 Hz或60 Hz操作，用于制造或进口，以在国内市场销售：",
  "office_appl_3": "数字电视适配器、带有电缆、卫星或互联网协议（IP）信号接收的解码器。",
  "office_appl_4": "用于图像再现的设备，如打印机、扫描仪、复印机和多功能设备。",
  "office_appl_5": "微波炉。",
  "office_appl_6": "用于独立、可分离或不可分离的音频再现的设备，用于一种或多种声音功能",
  "office_appl_7": "用于家庭影院的视频再现设备，使用数字多用途光盘（DVD）或高清数字光盘（Blu-Ray Disc）格式。",
  "office_appl_8": "带有发光二极管（LED）、液晶（LCD）、等离子（PDP）和有机发光二极管（OLED）屏幕的电视。",
  "at_mcb": "在墨西哥认证机构，我们理解我们用户对高效处理认证服务的需求，因此我们开发了流程，使我们能够提供有效和专业的响应，确保我们服务的技术可靠性；不损害我们区别于他人的规范框架和质量。",
  "public_info_1": "我们为您提供必要的信息和文件，以便您提交您的认证服务申请并符合我们能覆盖的墨西哥官方标准。",
  "public_info_2": "如有任何澄清或疑问，我们随时欢迎您通过以下联系方式与我们联系：",
  "public_info_3": "电气与电子安全",
  "public_info_4": "能源效率",
  "public_info_5": "电信",
  "public_info_6": "实验室列表",
  "public_info_7": "合法注册要求",
  "public_info_8": "海关信函",
  "nom003_scope_appliances": "家用电器",
  "nom003_scope_tools": "电动工具",
  "pw-usage": "密码使用",
  "service-contract": "服务合同",
  "elect-application": "电子申请",
  "elect-cert-req": "电子认证要求",
  "telecom-application": "电信申请",
  "req-eff": "效率要求",
  "cert-eff-req": "效率认证要求",
  "cert-reqs": "认证要求",
  "sample-mgmt": "样品管理",
  "lab-cat": "实验室目录",
  "must_read": "必读",
  "date": "日期",
  "time": "时间",
  "duration": "持续时间",
  "webn-elect": "电子网络研讨会",
  "webn-tele": "电信网络研讨会",
  "price-list": "价格列表",
  "name": "姓名",
  "company": "公司",
  "email": "电子邮件",
  "tel": "电话",
  "reg-now": "立即注册",
  "thanks-reg": "感谢您的注册！我们的工作人员将很快与您联系。",
  "virt-assist": "您的虚拟助手",
  "virt-assist-placeholder": "在此输入您的问题",
  "news_title_1": "墨西哥官方标准NOM-008-SE-2021，测量单位通用系统",
  "news_body_1": "在多个国家中，经常使用与国际单位系统不同的单位系统。因此，这一墨西哥官方标准基于国际计量局（BIPM）在2019年发布的国际单位系统SI的文件。 <br />其目的是定义官方必须在该国使用的单位系统，根据质量基础设施法第97条的规定。经济部于2023年12月29日在联邦官方公报中发布了墨西哥官方标准 <a href='https://www.dof.gob.mx/nota_detalle.php?codigo=5713228&fecha=29/12/2023#gsc.tab=0' target='_blank'>NOM-008-SE-2021</a>，即废除NOM-008-SCFI-2002的通用测量单位系统。",
  "news_title_2": "IFT-016-2023技术规定",
  "news_body_2": "2023年12月1日，联邦电信研究所（IFT）在其网站上发布了“IFT-016-2023技术规定草案。低功率无线电通信设备：在30 MHz至3 GHz频段内使用无线电频谱的设备 - 规格、限制和测试方法”，目的是接收任何个人或法人关于这项新规定的评论、意见和贡献，截止日期为2024年3月29日。",
  "comp-appeal_1": "在MCB，我们非常重视用户满意度，因此我们提供了一种投诉或申诉的格式，以防您对服务或所作决定不满意或不同意，或者如果您愿意，您也可以分享您的评论或建议，以改善我们提供的服务。",
  "comp-appeal_2": "我们向您说明，发送的信息按照MCB设定的公正和保密原则进行处理。请将您的表格发送到电子邮箱 <a href='mailto:contacto@mexicocb.com.mx'>contacto@mexicocb.com.mx</a>，我们将负责跟进您的请求。",
  "comp-appeal_3": "投诉或申诉请求",
  "comp-appeal_4": "投诉和申诉处理流程",
  "meet-us_1": "对于墨西哥认证机构而言，与我们的用户和社会大众建立信任关系非常重要，因此我们的设施大门始终对外开放，您可以来了解我们的设施和合作伙伴，以及机构在合规评估活动中的运作。",
  "meet-us_2": "我们的位置在：",
  "meet-us_3": "Av. Insurgentes Sur 800, Int. Piso 11 Oficina 1 D<br />Del Valle Centro, C.P. 03100<br />Benito Juárez, Ciudad de México.",
  "meet-us_4": "周一至周五上午8:00至下午5:00",
  "curr-certs": "当前证书",
  "news_title_3": "墨西哥认证机构SC（MCB），获得联邦电信研究所授权",
  "news_body_3": "<p>2024年6月27日，墨西哥认证机构SC（MCB）获得联邦电信研究所（IFT）的授权，作为产品认证机构（OCP）在以下范围内运作：</p><ul><li>NOM-196-SCFI-2016（IFT-004-2016）</li><li>NOM-208-SCFI-2016（IFT-008-2015）</li><li>NOM-218-SCFI-2017（IFT-005-2016）</li><li>NOM-221-SCFI-2017（IFT-011-2017：第1部分）</li><li>NOM-221/2-SCFI-2018（IFT-011-2017：第2部分）</li><li>IFT-012-2019</li><li>IFT-011-2022：第3部分</li></ul><p>官方文件编号IFT/223/UCS/4191/2024，日期为2024年6月21日。</p><p>MCB成立为一个可靠的组织，拥有高素质的员工和一个动态且易于使用的服务平台。</p>",
  "news_title_4": "",
  "news_body_4": "<p>2024年6月14日，联邦电信研究所（IFT）在其门户网站上发布了<a href=\"https://www.ift.org.mx/industria/consultas-publicas/anteproyecto-de-acuerdo-mediante-el-cual-el-pleno-del-instituto-federal-de-telecomunicaciones-2\">草案协议，其中联邦电信研究所全体修改了用于电信或广播的产品、设备、装置或器具的认证指南</a>，目的是征求任何人（自然人或法人）对修改用于电信或广播的产品、设备、装置或器具的认证指南的意见和建议。</p>",
  "news_comment_4": "该草案的主要目的是修改用于电信或广播的产品、设备、装置或装置的批准指南，目的是参考 IFT 印章的要求作为标志或广播的附加要素。经研究所批准用于电信或广播的产品、设备、装置或装置的标签",
  "cert-reqs-tel": "电信认证要求",
  "list-req-legal": "法律要求清单",
  "customs-letter-req": "海关信函请求",
  "regulatory-updates": "监管更新",
  "official-nom": "官方NOM",
  "industry-updates": "行业更新",
  "mcb-updates": "MCB更新",
  "ift_015_2018_title": "专用移动车队无线电通信服务发射设备的技术规格",
  "ift_015_2018_scope": "本技术规定适用于所有用于车队专用移动无线电通信服务的设备。以上不影响遵守其他适用的法律和行政规定。",
  "ift_016_2024_title": "利用无线电频谱中 30 MHz 至 3 GHz 频段的设备。",
  "ift_016_2024_scope": "它适用于所有可以使用 30 MHz 至 3 GHz 范围内无线电频谱频段的低功率无线电通信设备、装置或产品。",
  "ift_017_2023_title": "采用数字调制，工作频率为 5150 MHz-5250 MHz、5250 MHz-5350 MHz、5470 MHz-5600 MHz、5650 MHz-5725 MHz、5725 MHz-5850 MHz 和 5925 MHz-6425 MHz 频段的无线电通信设备。",
  "ift_017_2023_scope": "本规定适用于所有用于电信的产品、设备、装置或装置，或在适用情况下, 适用于旨在连接到电信网络并使用无线电频谱的电信系统，这些系统采用数字调制技术、使用无线接入、在局域网中使用，并且在以下任何频段中运行：5150 MHz–5250 MHz、5250 MHz–5350 MHz、5470 MHz–5600 MHz、5650 MHz–5725 MHz、5725 MHz–5850 MHz 和 5925 MHz–6425 MHz，或所有这些频段的组合。",
  "previous": "上一页",
  "next": "下一页",
  "page": "页",
  "of": "共",
}

export default zh;